import React, {Fragment, useState} from 'react'
import {
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    Transition,
} from '@headlessui/react'
import { Bars3Icon, BellIcon, XMarkIcon, UserIcon, ArrowRightOnRectangleIcon } from '@heroicons/react/24/outline'
import {Outlet, useNavigate} from "react-router-dom";
import { useAuth } from './components/AuthContext';



// const navigation = [
//     { name: 'Dashboard', component: <Dashboard />, current: true },
//     { name: 'My Requests', component: <MyRequests />, current: false},
//     { name: 'Administrator', component: <Administrator />, current: false},
//     { name: 'On-Campus Event Request', component: <MasterCalendarForm />, current: false}
// ]

const navigation = [
    { name: 'Dashboard', path: 'dashboard', current: false},
    { name: 'My Requests', path: 'request', current: false },
    { name: 'Administrator', path: 'administrator', current: false },
    { name: 'On-Campus Event Request', path: 'form', current: false },
    { name: "Pastor's Tools", path: 'pastors-tools', current: false },
    // { name: 'Room Scheduler', path: 'schedule', current: false }
    // { name: 'Purchase Orders', path: 'purchase-orders', current: false },
    // { name: 'Account & Vendor Manager', path: 'accounts-vendors', current: false },
];

const userNavigation = [
    { name: 'Your Profile', action: 'profile', icon: UserIcon },
    { name: 'Sign out', action: 'signout', icon: ArrowRightOnRectangleIcon },
]

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function MainView() {
    const { user, signOut } = useAuth();
    const navigate = useNavigate();

    const [currentTab, setCurrentTab] = useState(navigation[0]);

    const handleTabClick = (item) => {
        setCurrentTab(item)
        navigate(item.path);
    };

    const handleUserMenuClick = async (action) => {
        if (action === 'signout') {
            try {
                await signOut();
                navigate('/'); // Redirect to login page
            } catch (error) {
                console.error('Error signing out:', error);
            }
        } else if (action === 'profile') {
            // For now, show an alert with user info - can be enhanced later
            alert(`Profile: ${user?.name}\nEmail: ${user?.email}`);
        }
    };

    return (
        <>
            <div className="min-h-full">
                <Disclosure as="nav" className="border-b border-gray-200 bg-white">
                    {({ open }) => (
                        <>
                            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                                <div className="flex h-16 justify-between">
                                    <div className="flex">
                                        <div className="flex flex-shrink-0 items-center">
                                            <img
                                                className="block h-8 w-auto lg:hidden"
                                                src={process.env.PUBLIC_URL + "/bethel-favicon.png"}
                                                alt="Bethel Favicon"
                                            />
                                            <img
                                                className="hidden h-8 w-auto lg:block"
                                                src={process.env.PUBLIC_URL + "/bethel-favicon.png"}
                                                alt="Bethel Favicon"
                                            />
                                            <img
                                                className="block h-8 w-auto lg:block"
                                                src={process.env.PUBLIC_URL + "/church-logo.png"}
                                                alt="Church Logo"
                                            />
                                        </div>
                                        <div className="hidden sm:-my-px sm:ml-6 sm:flex sm:space-x-8">
                                            {navigation.map((item) => (
                                                <button
                                                    key={item.name}
                                                    onClick={() => handleTabClick(item)}
                                                    className={classNames(
                                                        item === currentTab
                                                            ? 'border-indigo-500 text-gray-900'
                                                            : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                                                        'inline-flex items-center border-b-2 px-1 pt-1 text-sm font-medium cursor-pointer'
                                                    )}
                                                    aria-current={item === currentTab ? 'page' : undefined}
                                                >
                                                    {item.name}
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                    <div className="hidden sm:ml-6 sm:flex sm:items-center">
                                        <button
                                            type="button"
                                            className="relative rounded-full bg-white p-1 text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                        >
                                            <span className="absolute -inset-1.5" />
                                            <span className="sr-only">View notifications</span>
                                            <BellIcon className="h-6 w-6" aria-hidden="true" />
                                        </button>

                                        {/* Profile dropdown */}
                                        <Menu as="div" className="relative ml-3">
                                            <div>
                                                <MenuButton className="relative flex max-w-xs items-center rounded-full bg-white text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                                                    <span className="absolute -inset-1.5" />
                                                    <span className="sr-only">Open user menu</span>
                                                    <img className="h-8 w-8 rounded-full" src={user?.picture} alt="" />
                                                </MenuButton>
                                            </div>
                                            <Transition
                                                enter="transition ease-out duration-200"
                                                enterFrom="transform opacity-0 scale-95"
                                                enterTo="transform opacity-100 scale-100"
                                                leave="transition ease-in duration-75"
                                                leaveFrom="transform opacity-100 scale-100"
                                                leaveTo="transform opacity-0 scale-95"
                                            >
                                                <MenuItems className="absolute right-0 z-10 mt-2 w-64 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                                    {/* User Info Header */}
                                                    <div className="px-4 py-2 border-b border-gray-100">
                                                        <div className="text-sm font-medium text-gray-900">{user?.name}</div>
                                                        <div className="text-xs text-gray-500">{user?.email}</div>
                                                    </div>
                                                    {userNavigation.map((item) => (
                                                        <MenuItem key={item.name}>
                                                            {({ focus }) => (
                                                                <button
                                                                    onClick={() => handleUserMenuClick(item.action)}
                                                                    className={classNames(
                                                                        focus ? 'bg-gray-100' : '',
                                                                        'flex w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100'
                                                                    )}
                                                                >
                                                                    <item.icon className="mr-3 h-4 w-4 text-gray-400" aria-hidden="true" />
                                                                    {item.name}
                                                                </button>
                                                            )}
                                                        </MenuItem>
                                                    ))}
                                                </MenuItems>
                                            </Transition>
                                        </Menu>
                                    </div>
                                    <div className="-mr-2 flex items-center sm:hidden">
                                        {/* Mobile menu button */}
                                        <DisclosureButton className="relative inline-flex items-center justify-center rounded-md bg-white p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                                            <span className="absolute -inset-0.5" />
                                            <span className="sr-only">Open main menu</span>
                                            {open ? (
                                                <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                                            ) : (
                                                <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                                            )}
                                        </DisclosureButton>
                                    </div>
                                </div>
                            </div>

                            <DisclosurePanel className="sm:hidden">
                                <div className="space-y-1 pb-3 pt-2">
                                    {navigation.map((item) => (
                                        <DisclosureButton
                                            key={item.name}
                                            as="a"
                                            href={item.href}
                                            className={classNames(
                                                item.current
                                                    ? 'border-indigo-500 bg-indigo-50 text-indigo-700'
                                                    : 'border-transparent text-gray-600 hover:border-gray-300 hover:bg-gray-50 hover:text-gray-800',
                                                'block border-l-4 py-2 pl-3 pr-4 text-base font-medium'
                                            )}
                                            aria-current={item.current ? 'page' : undefined}
                                        >
                                            {item.name}
                                        </DisclosureButton>
                                    ))}
                                </div>
                                <div className="border-t border-gray-200 pb-3 pt-4">
                                    <div className="flex items-center px-4">
                                        <div className="flex-shrink-0">
                                            <img className="h-10 w-10 rounded-full" src={user?.picture} alt="" />
                                        </div>
                                        <div className="ml-3">
                                            <div className="text-base font-medium text-gray-800">{user?.name}</div>
                                            <div className="text-sm font-medium text-gray-500">{user?.email}</div>
                                        </div>
                                        <button
                                            type="button"
                                            className="relative ml-auto flex-shrink-0 rounded-full bg-white p-1 text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                        >
                                            <span className="absolute -inset-1.5" />
                                            <span className="sr-only">View notifications</span>
                                            <BellIcon className="h-6 w-6" aria-hidden="true" />
                                        </button>
                                    </div>
                                    <div className="mt-3 space-y-1">
                                        {userNavigation.map((item) => (
                                            <DisclosureButton
                                                key={item.name}
                                                as="button"
                                                onClick={() => handleUserMenuClick(item.action)}
                                                className="flex w-full items-center px-4 py-2 text-base font-medium text-gray-500 hover:bg-gray-100 hover:text-gray-800"
                                            >
                                                <item.icon className="mr-3 h-5 w-5 text-gray-400" aria-hidden="true" />
                                                {item.name}
                                            </DisclosureButton>
                                        ))}
                                    </div>
                                </div>
                            </DisclosurePanel>
                        </>
                    )}
                </Disclosure>
            </div>
            <div className="p-4">
                {/*{currentTab.component}*/}
                <Outlet />
            </div>
        </>
    )
}
